import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getAdMarketPublishGroupCode, getMarketCountryCode } from "./sharedAdsUtils";

// Brazil:  https://iapp.org/news/a/an-overview-of-brazils-lgpd/.
// China: https://www.cookielawinfo.com/china-pipl/.
// Turkey: https://gun.av.tr/insights/updates/guidelines-on-use-of-cookies-in-turkey
// Canada, Quebec: https://www.cookieyes.com/blog/quebec-law-25/
// Vietnam: https://www.dataguidance.com/notes/vietnam-data-protection-overview
export function checkAndGetLgpdAdMarket(): boolean | string {
    const lgpdAdMarkets = ["BR", "CA", "CN", "TR"];
    
    if (isGlobalFeatureEnabled("adsexp-vietnamConsent")) {
        lgpdAdMarkets.push("VN");
    }
    
    const countryCode = getMarketCountryCode(getAdMarketPublishGroupCode());
    return lgpdAdMarkets.indexOf(countryCode) >= 0 ? countryCode : false;
}
